var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(-168 -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(168 12)",
    fill: "#ebf9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-parking",
    "data-name": "Icon awesome-parking",
    d: "M16.071,2.25H1.929A1.929,1.929,0,0,0,0,4.179V18.321A1.929,1.929,0,0,0,1.929,20.25H16.071A1.929,1.929,0,0,0,18,18.321V4.179A1.929,1.929,0,0,0,16.071,2.25ZM9.643,13.821H7.714V15.75a.645.645,0,0,1-.643.643H5.786a.645.645,0,0,1-.643-.643v-9a.645.645,0,0,1,.643-.643H9.643a3.857,3.857,0,0,1,0,7.714Zm0-5.143H7.714V11.25H9.643a1.286,1.286,0,1,0,0-2.571Z",
    transform: "translate(177 18.75)",
    fill: "#00aec4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingActive);
export default __webpack_public_path__ + "static/media/parking-active.f3734bea7277bede47ac2835ad98ef1e.svg";
export { ForwardRef as ReactComponent };